import * as  React from 'react'
import { Modal } from '@doordash/component-modal'
import Button from '@doordash/component-button'
import Toggle from '@doordash/component-toggle'
import { Text, StackChildren } from '@doordash/design-language'
import i18n from '../../../../../i18n'
import { i18nKeys } from 'translationTypes'
import * as DA from '../../../../../typeModules/events'

const handleSubmit = (onSubmit, hasGivenConsent, setErrror) => {
  if (!hasGivenConsent) {
    setErrror(i18n.t(i18nKeys.startedSigningUp_sms_prompt_consent_error))
  } else {
    setErrror()
    onSubmit()
  }
}

export const SmsSentPrompt = ({
  onClick,
  onClose,
  onBack,
  isSending = false,
  trackReturnToApplication
}) => {
  React.useEffect(() => {
    trackReturnToApplication(
      DA.EventActions.Rendered,
      DA.ReturnToApplication.ReclaimSMS
    )
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  // TODO(markn): remove above disable after updating lint rule

  const [hasGivenSmsConsent, setHasGivenSmsConsent] = React.useState(false)
  const [error, setError] = React.useState(null)

  return (
    <Modal
      title={i18n.t(i18nKeys.startedSigningUp_sms_prompt_title)}
      onClose={onClose}
      isFullScreenOnMobile={false}
      primaryAction={{
        text: i18n.t(i18nKeys.startedSigningUp_sms_prompt_button_text),
        onClick: () => handleSubmit(onClick, hasGivenSmsConsent, setError),
        buttonProps: {
          state: isSending ? Button.States.Loading : Button.States.Default
        }
      }}
      secondaryAction={{
        text: i18n.t(i18nKeys.common__back),
        onClick: onBack,
      }}
      actionsFillContainer
    >
      <StackChildren>
        <Text
          styles={Text.Styles.Label2}
          color={Text.Colors.TextSecondary}
        >
          {i18n.t(i18nKeys.startedSigningUp_sms_prompt_description)}
        </Text>
        <Toggle
          isSelected={hasGivenSmsConsent}
          onChange={setHasGivenSmsConsent}
          error={error}
          renderLabel={() => (
            <Text
              styles={Text.Styles.Body2}
              color={Text.Colors.TextTertiary}
            >
              {i18n.t(i18nKeys.startedSigningUp_sms_prompt_consent)}
            </Text>
        )} />
      </StackChildren>
    </Modal>
  )
}
